// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__20UMd","calendarButtons":"ClockData_calendarButtons__8wS0L"};